import React, { useState } from "react"
import {
  addExaminer,
  clearExaminersList,
  deleteExaminer,
  searchExaminers,
} from "../../../../../../library/store/actions/creators/knowmixCreators"
import { useDispatch, useSelector } from "react-redux"
import { generatePath, Link, useParams } from "react-router-dom"
import DropdownControl from "../../../../../../components/ui/dropdowns/dropdownControl/dropdownControl"
import MenuList from "@material-ui/core/MenuList/MenuList"
import Button from "@material-ui/core/Button/Button"
import { withStyles } from "@material-ui/core"
import { colors } from "../../../../../../library/constants/styles/colors"
import MenuItem from "@material-ui/core/MenuItem/MenuItem"
import userAvatarDefault from "../../../../../../assets/img/user_avatar.svg"
import * as routes from "../../../../../../library/constants/routes"
import { userRolesIds } from "../../../../../../library/constants/userRoles"
import { getUserLocationString } from "../../../../../../library/utils/getUserLocationString"
import LinesEllipsis from "react-lines-ellipsis"
import { useAlert } from "../../../../../../hooks/useAlert"
import ListPage from "../../../../../../components/v2/layout/listPage/listPage"
import withErrorBoundary from "../../../../../../hocs/guards/withErrorBoundary"

const CustomMenuItem = withStyles({
  root: {
    color: colors.primary,
  },
})(MenuItem)

const KnowmixSettingsExaminers = () => {
  const { errorAlert } = useAlert()
  const dispatch = useDispatch()
  const params = useParams()

  const { examinersList, examinersListEndReached } = useSelector(
    ({ knowmix }) => knowmix
  )

  const onAddExaminer = async (user_id) => {
    try {
      await dispatch(
        addExaminer({ knowmix_id: parseInt(params.knowmixId, 10), user_id })
      )
    } catch (e) {
      errorAlert(e)
    }
  }

  const onDeleteExaminer = async (user_id) => {
    try {
      await dispatch(
        deleteExaminer({ knowmix_id: parseInt(params.knowmixId, 10), user_id })
      )
    } catch (e) {
      errorAlert(e)
    }
  }

  return (
    <ListPage
      title={'People'}
      getList={async ({ name, offset }) =>
        await dispatch(
          searchExaminers({
            id: parseInt(params.knowmixId, 10),
            name,
            offset,
          })
        )
      }
      clearList={() => dispatch(clearExaminersList())}
      list={examinersList}
      listEndReached={examinersListEndReached}
      getListItemComponent={({ item }) => (
        <ListItemUser
          user={item}
          addExaminer={onAddExaminer}
          deleteExaminer={onDeleteExaminer}
          key={item.id}
        />
      )}
    />
  )
}

const ListItemUser = ({ user, ...rest }) => {
  const [isExaminer, setIsExaminer] = useState(user.is_examiner)

  const addExaminer = async () => {
    await rest.addExaminer(user.id)
    setIsExaminer(true)
  }

  const deleteExaminer = async () => {
    await rest.deleteExaminer(user.id)
    setIsExaminer(false)
  }

  const photoUrl = user.photo !== '' ? user.photo : userAvatarDefault
  const fullName = `${user.first_name} ${user.last_name}`
  const profileUrl = generatePath(routes.USER, { userId: user.id })
  const addressInfoBlock = getUserLocationString(user)

  return (
    <div className="box list-item">
      <div className="f aic full-width">
        <Link to={profileUrl} className="list-item__img">
          <img src={photoUrl} alt={fullName} />
        </Link>
        <div className="list-item__info">
          <span className="color-black-38 font-13">
            {userRolesIds[user.role].name}
          </span>
          <Link to={profileUrl} className="link list-item__name">
            {fullName}
          </Link>

          {getUserLocationString(user) && (
            <span className="list-item__info-block">
              <LinesEllipsis
                text={getUserLocationString(user)}
                maxLine="1"
                ellipsis="..."
                trimRight
                basedOn="letters"
              />
            </span>
          )}
        </div>
      </div>
      <div className="list-item__control-panel jcc">
        {isExaminer ? (
          <DropdownControl buttonLabel="Examiner">
            <MenuList>
              <CustomMenuItem onClick={deleteExaminer}>
                Remove from examiners
              </CustomMenuItem>
            </MenuList>
          </DropdownControl>
        ) : (
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={addExaminer}
          >
            Add to examiners
          </Button>
        )}
      </div>
    </div>
  )
}

export default withErrorBoundary(KnowmixSettingsExaminers)
